const steps = [
  {
    num: '01',
    icon: 'ri-phone-line',
    title: 'Request a Free Estimate',
    desc: 'Contact us online or by phone. We schedule your free in-home consultation at your convenience — same-week availability.',
    highlight: 'Free & No Obligation',
  },
  {
    num: '02',
    icon: 'ri-home-search-line',
    title: 'In-Home Assessment',
    desc: 'Our expert visits, evaluates your floors in person, discusses your goals, and provides a detailed written quote.',
    highlight: 'Written Quote Provided',
  },
  {
    num: '03',
    icon: 'ri-palette-line',
    title: 'Material & Finish Selection',
    desc: 'Choose from premium wood species, plank widths, stain colors, and finishes to perfectly match your home\'s aesthetic.',
    highlight: '20+ Wood Species',
  },
  {
    num: '04',
    icon: 'ri-tools-line',
    title: 'Expert Installation',
    desc: 'Our craftsmen execute with precision and care. Clean worksite daily, dust minimized, and your schedule respected.',
    highlight: 'Dust-Minimized Process',
  },
  {
    num: '05',
    icon: 'ri-checkbox-circle-line',
    title: 'Final Walkthrough & Approval',
    desc: 'We walk through every detail with you. You approve, we\'re done — and we\'re still a call away afterward.',
    highlight: '100% Satisfaction Focus',
  },
];

export default function ProcessSection() {
  return (
    <section className="bg-walnut py-28 px-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]"
        style={{ backgroundImage: 'repeating-linear-gradient(-45deg, #C8A96A 0, #C8A96A 1px, transparent 0, transparent 40%)', backgroundSize: '20px 20px' }}
      />

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-sans text-xs uppercase tracking-widest text-gold font-semibold">Simple & Transparent</span>
          <h2 className="font-serif text-4xl md:text-5xl text-white font-bold mt-3 leading-tight">
            Our Process — 5 Simple Steps
          </h2>
          <p className="font-sans text-white/55 mt-5 text-base max-w-xl mx-auto">
            From first contact to final walkthrough, we keep you informed, in control, and comfortable at every step.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {steps.map((step, idx) => (
            <div key={step.num} className="relative">
              {/* Connector line */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-px bg-white/10 z-0" style={{ width: 'calc(100% - 3rem)', left: 'calc(50% + 1.5rem)' }} />
              )}

              <div className="bg-white/5 border border-white/10 rounded-2xl p-6 text-center hover:bg-white/10 transition-all duration-300 relative z-10 h-full flex flex-col">
                {/* Step number + icon */}
                <div className="relative w-20 h-20 mx-auto mb-5">
                  <div className="w-20 h-20 bg-white/10 rounded-full flex flex-col items-center justify-center border-2 border-white/20">
                    <span className="font-serif text-gold font-bold text-lg leading-none">{step.num}</span>
                    <i className={`${step.icon} text-white/70 text-sm mt-0.5`} />
                  </div>
                </div>

                <h3 className="font-sans text-sm font-bold text-white mb-2 leading-snug">{step.title}</h3>
                <p className="font-sans text-xs text-white/55 leading-relaxed flex-1 mb-4">{step.desc}</p>
                <div className="inline-flex items-center justify-center gap-1.5 bg-gold/15 rounded-full px-3 py-1.5 mx-auto">
                  <i className="ri-checkbox-circle-fill text-gold text-xs" />
                  <span className="font-sans text-xs text-gold font-semibold">{step.highlight}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
